// extracted by mini-css-extract-plugin
export default {"mainWrapper":"consolidate_mainWrapper__NmGVR","actionButtons":"consolidate_actionButtons__Bi0ZH"};